import { constraints, datatypes, inputTypes } from "data/globalData";

export const qtySizeSplitColumns = {
	size: {
		name: "Size",
		key: "size",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	order_qty: {
		name: "Order Qty",
		key: "order_qty",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.NUMBER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	recieved_qty: {
		name: "Recieved Qty",
		key: "recieved_qty",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.NUMBER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	difference_qty: {
		name: "Difference Qty",
		key: "difference_qty",
		input_type: inputTypes.AUTO_GENERATE.key,
		data_type: datatypes.NUMBER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
};

export const dummyTableData = [
	{
		id: 1,
		fabric_quality: "100% COTTON POPLIN",
		description: "BODY FABRIC",
		consumption: 2.2,
		order_qty: 155.0,
		recieved_qty: 341,
		supplier: "Benkatesh",
	},
	{
		id: 2,
		fabric_quality: "100% cotton  VOILE 92X80",
		description: "LINING",
		consumption: 1.53,
		order_qty: 92.0,
		recieved_qty: 140.76,
		supplier: "Drishya",
	},
];
export const defaultTotalRow = {
	id: "TOTAL",
	size: "TOTAL",
	order_qty: 0,
	recieved_qty: 0,
	difference_qty: 0,
};

export const checkForTotalColumn = (row) => {
	if (row.id === "TOTAL" || row?.[qtySizeSplitColumns.size.key] === "TOTAL") return true;
	return false;
};
export const calculateTotalRow = (allRows) => {
	let order_qty = 0;
	let recieved_qty = 0;
	let difference_qty = 0;
	allRows?.forEach((row) => {
		if (!isNaN(row?.[qtySizeSplitColumns.order_qty.key])) order_qty += +row?.[qtySizeSplitColumns.order_qty.key];
		if (!isNaN(row?.[qtySizeSplitColumns.recieved_qty.key])) recieved_qty += +row?.[qtySizeSplitColumns.recieved_qty.key];
		if (!isNaN(row?.[qtySizeSplitColumns.difference_qty.key])) difference_qty += +row?.[qtySizeSplitColumns.difference_qty.key];
	});
	return {
		...defaultTotalRow,
		[qtySizeSplitColumns.order_qty.key]: order_qty,
		[qtySizeSplitColumns.recieved_qty.key]: recieved_qty,
		[qtySizeSplitColumns.difference_qty.key]: difference_qty,
	};
};
